var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4583 1.41667H10.4975C10.2 0.595 9.42083 0 8.5 0C7.57917 0 6.8 0.595 6.5025 1.41667H3.54167C2.7625 1.41667 2.125 2.05417 2.125 2.83333V14.1667C2.125 14.9458 2.7625 15.5833 3.54167 15.5833H13.4583C14.2375 15.5833 14.875 14.9458 14.875 14.1667V2.83333C14.875 2.05417 14.2375 1.41667 13.4583 1.41667ZM8.5 1.41667C8.88958 1.41667 9.20833 1.73542 9.20833 2.125C9.20833 2.51458 8.88958 2.83333 8.5 2.83333C8.11042 2.83333 7.79167 2.51458 7.79167 2.125C7.79167 1.73542 8.11042 1.41667 8.5 1.41667ZM13.4583 14.1667H3.54167V2.83333H4.95833V4.95833H12.0417V2.83333H13.4583V14.1667Z",
    fill: "#20F092"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.619dd8b95d07222f247170ced9ed8b07.svg";
export { ForwardRef as ReactComponent };